import { resolveLineTaxes, type CalculatedTax, type DocumentTaxDefinition, type DocumentTaxes, type DocumentTaxSet, type TaxMode } from "./document-taxes";

export interface DocumentTaxOutputRow {
  id: string;
  name: string;
  rateBasisPoints: number;
  amountMinor: number;
}

// Present the already-calculated amounts; do not recompute tax or rounding.
export function aggregateDocumentTaxBreakdown(lines: readonly { taxBreakdown?: readonly CalculatedTax[] }[]): DocumentTaxOutputRow[] {
  const rows = new Map<string, DocumentTaxOutputRow>();
  for (const line of lines) {
    for (const tax of line.taxBreakdown ?? []) {
      const previous = rows.get(tax.definition.id);
      rows.set(tax.definition.id, {
        id: tax.definition.id,
        name: tax.definition.name,
        rateBasisPoints: tax.definition.rateBasisPoints,
        amountMinor: (previous?.amountMinor ?? 0) + tax.amountMinor,
      });
    }
  }
  return [...rows.values()];
}

// A failed calculation has no amounts; retain only canonically resolved labels.
export function resolveDocumentTaxOutputDefinitions(taxes: DocumentTaxes, lines: readonly { taxMode: TaxMode; taxSet?: DocumentTaxSet }[]): DocumentTaxDefinition[] {
  const definitions = new Map<string, DocumentTaxDefinition>();
  for (const line of lines) {
    for (const tax of resolveLineTaxes(taxes, line.taxMode, line.taxSet)) definitions.set(tax.id, tax);
  }
  return [...definitions.values()];
}
